import { combineReducers } from "redux";
import loginReducer  from "./Reducers/loginReducer";
import projectReducer from "./Reducers/projectReducer";
import projectDetailsReducer from "./Reducers/projectDetailsReducer";
import employeeReducer from "./Reducers/employeeReducer";
import clientReducer from "./Reducers/clientListReducer";
import clientDetailsReducer from "./Reducers/clientDetailsReducer";

import userRolesListReducer from "./Reducers/userRolesListReducer";
import userPermissionsListReducer from "./Reducers/userPermissionListReducer";
import forogotPasswordReducer from "./Reducers/forgotPasswordReducer";
import myTaskListReducer from "./Reducers/myTaskListReducer";
import weeklyTimesheetsReducer from "./Reducers/weeklyTimesheetReducer";
import getAllEmployeeTask from "./Reducers/getAllEmployeeTask";
import empWeeklyTimesheetsReducer from "./Reducers/getAllEmpTimesheetReducer";
import getEachWeekTimesheet from "./Reducers/getEachWeekTimesheet";
import getEachWeekTimesheetReducer from "./Reducers/getEachWeekTimesheet";
import changePasswordReducer from "./Reducers/changePasswordReducer";
import invoiceReducer from "./Reducers/invoiceReducer"; 
import uploadReducer from "./Reducers/uploadReducer";

const rootReducer = combineReducers({
login:loginReducer,
project:projectReducer,
projectDetails:projectDetailsReducer,
employees:employeeReducer,
clientsList: clientReducer,
clientDetails:clientDetailsReducer,
userRoles:userRolesListReducer,
userPermissions:userPermissionsListReducer,
forgotPassword:forogotPasswordReducer,
myTasksList:myTaskListReducer,
allEmpTask:getAllEmployeeTask,
weeklyTimesheets:weeklyTimesheetsReducer,
empWeeklyTimesheets:empWeeklyTimesheetsReducer,
eachWeeKTimesheet:getEachWeekTimesheetReducer,
changePassword: changePasswordReducer,
invoices: invoiceReducer,
upload: uploadReducer

})

export default rootReducer;